<section class="home-shell">
  <header class="hero">
    <div>
      <p class="hero-eyebrow">Dashboard</p>
      <h1 class="hero-title">Painel de Controle</h1>
      <p class="hero-subtitle">Indicadores mensais comparados ao período anterior.</p>
    </div>
    <button type="button" class="btn-refresh" (click)="load()">Atualizar indicadores</button>
  </header>

  <div class="dashboard-grid">

    <!-- Leads -->
    <article class="metric-card metric-leads">
      <div class="metric-header">
        <div class="metric-meta">
          <span class="metric-eyebrow">CRM</span>
          <h3 class="metric-name">{{ leadsIndicador.title }}</h3>
          <p class="metric-subtitle">{{ leadsIndicador.periodLabel }}</p>
        </div>
        @if (!leadsIndicador.isLoading) {
          <div class="metric-trend-badge" [class.negative]="!leadsIndicador.trendPositive">
            {{ leadsIndicador.trendPositive ? '↑' : '↓' }}&nbsp;{{ leadsIndicador.trend | number:'1.1-1' }}%
          </div>
        }
      </div>

      @if (leadsIndicador.isLoading) {
        <div class="metric-loading">
          <span class="spinner-border spinner-border-sm"></span>
          <span>Carregando...</span>
        </div>
      } @else {
        <div class="metric-value">{{ leadsIndicador.currentValue | number:'1.0-0' }}</div>
        <p class="metric-comparison">
          vs <strong>{{ leadsIndicador.previousValue | number:'1.0-0' }}</strong> no período anterior
        </p>
      }
    </article>

    <!-- Orçamentos -->
    <article class="metric-card metric-orcamentos">
      <div class="metric-header">
        <div class="metric-meta">
          <span class="metric-eyebrow">Financeiro</span>
          <h3 class="metric-name">{{ orcamentosIndicador.title }}</h3>
          <p class="metric-subtitle">{{ orcamentosIndicador.periodLabel }}</p>
        </div>
        @if (!orcamentosIndicador.isLoading) {
          <div class="metric-trend-badge" [class.negative]="!orcamentosIndicador.trendPositive">
            {{ orcamentosIndicador.trendPositive ? '↑' : '↓' }}&nbsp;{{ orcamentosIndicador.trend | number:'1.1-1' }}%
          </div>
        }
      </div>

      @if (orcamentosIndicador.isLoading) {
        <div class="metric-loading">
          <span class="spinner-border spinner-border-sm"></span>
          <span>Carregando...</span>
        </div>
      } @else {
        <div class="metric-value">{{ orcamentosIndicador.currentValue | number:'1.0-0' }}</div>
        <p class="metric-comparison">
          vs <strong>{{ orcamentosIndicador.previousValue | number:'1.0-0' }}</strong> no período anterior
        </p>
      }
    </article>

    <!-- Vendas -->
    <article class="metric-card metric-vendas">
      <div class="metric-header">
        <div class="metric-meta">
          <span class="metric-eyebrow">Comercial</span>
          <h3 class="metric-name">{{ vendasIndicador.title }}</h3>
          <p class="metric-subtitle">{{ vendasIndicador.periodLabel }}</p>
        </div>
        @if (!vendasIndicador.isLoading) {
          <div class="metric-trend-badge" [class.negative]="!vendasIndicador.trendPositive">
            {{ vendasIndicador.trendPositive ? '↑' : '↓' }}&nbsp;{{ vendasIndicador.trend | number:'1.1-1' }}%
          </div>
        }
      </div>

      @if (vendasIndicador.isLoading) {
        <div class="metric-loading">
          <span class="spinner-border spinner-border-sm"></span>
          <span>Carregando...</span>
        </div>
      } @else {
        <div class="metric-value">{{ vendasIndicador.currentValue | number:'1.0-0' }}</div>
        <p class="metric-comparison">
          vs <strong>{{ vendasIndicador.previousValue | number:'1.0-0' }}</strong> no período anterior
        </p>
      }
    </article>

  </div>
</section>
